import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import config from '../../../config';
import trainTime from '../../../lib/TrainTime';
import { JourneyDirections } from '../../../constants/AppConstants';
import Search from '../../../records/Search';
import Smartcard from '../../../records/customer/Smartcard';

import TimebandSelector from './TimebandSelector';
import BaseModal from '../../general/BaseModal';
import PureRenderComponent from '../../PureRenderComponent';

class TimebandModal extends PureRenderComponent {

    static propTypes = {
        show: PropTypes.bool,
        search: PropTypes.instanceOf(Search),
        smartcard: PropTypes.instanceOf(Smartcard),
        type: PropTypes.oneOf([JourneyDirections.OUTWARD, JourneyDirections.INWARD]),
        onCancel: PropTypes.func,
        onSelect: PropTypes.func
    };

    static defaultProps = {
        search: new Search(),
        show: false,
        onCancel: _.noop,
        onSelect: _.noop,
        type: null
    };

    state = {
        search: this.props.search
    };

    _getKey () {
        return this.props.type === JourneyDirections.INWARD ? 'returnDateTime' : 'outboundDateTime';
    }

    _handleChange = (value) => {
        var search = this.state.search.set(this._getKey(), value);
        this.setState({ search });
    };

    _onSelect = () => {
        this.props.onSelect(this.state.search);
    };

    _isDirty () {
        return this.props.search !== this.state.search;
    }


    render () {
        const { search } = this.state;
        const { smartcard, type, show, onCancel } = this.props;
        const timeband = search.get(this._getKey());

        const min = (search.smartcard && smartcard && smartcard.isAwaitingProduct()) ?
            trainTime().addWorkingDays(config.get('minAwaitingSmartcardProductDays')) : search.getMinDate(type);

        return (
            <BaseModal
                    show={ show }
                    onClose={ onCancel }
                    onContinue={ this._onSelect }
                    closeText={ 'button.text.cancel' }
                    continueText={ 'button.text.select' }
                    disableBlur={ this._isDirty() }
                    titleText={ `booking.dates.modal.title.${type}.${timeband.arriveDepart}` }
                    className="datetime__modal modal--md" >
                <section>
                    <TimebandSelector name={ type }
                        min={ min }
                        max={ search.getMaxDate(type) }
                        timeband={ timeband }
                        onChange={ this._handleChange } />
                </section>
            </BaseModal>
        );
    }

}

export default TimebandModal;



// WEBPACK FOOTER //
// ./src/components/search/dates/TimebandModal.js